export default function getCountries(state) {
    const { countries = {} } = state

    // Temporarily remove China from returned countries
    delete countries.CN

    const alphabeticalOrderedCountries = Object.fromEntries(
        Object.entries(countries).sort(([, country1], [, country2]) =>
            country1.countryName?.localeCompare(country2.countryName)
        )
    )

    return { countries: alphabeticalOrderedCountries }
}
